import { render, staticRenderFns } from "./ProductDetail.vue?vue&type=template&id=520b8966&scoped=true&"
import script from "./ProductDetail.vue?vue&type=script&lang=ts&"
export * from "./ProductDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDetail.vue?vue&type=style&index=0&id=520b8966&lang=scss&scoped=true&"
import style1 from "./ProductDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520b8966",
  null
  
)

export default component.exports